import gqlClient from '@discover-data/gql/client';
import MapRestaurantsQuery, {
  type QueryVariables,
} from '@discover-data/gql/queries/mapRestaurants';

export type GetMapRestaurantsParams = {
  variables: QueryVariables;
  abortSignal?: AbortSignal;
};

export default async function getMapRestaurants(
  variables: QueryVariables,
  abortSignal?: AbortSignal
) {
  const { allRestaurants } = await gqlClient({
    query: MapRestaurantsQuery,
    variables: {
      ...variables,
      siteId: variables.siteId || +(process.env.NEXT_PUBLIC_SITE_ID || 1),
      input: variables.input,
    },
    abortSignal,
  });

  const cleanRestaurants = (allRestaurants || []).filter(
    (
      restaurant
    ): restaurant is PartialNonNull<NonNullable<typeof restaurant>, 'id' | 'lat' | 'lng'> =>
      restaurant !== null && restaurant.id !== null
  );

  return cleanRestaurants;
}

export type Restaurant = ArrayElement<Awaited<ReturnType<typeof getMapRestaurants>>>;
